import { BottomShadow, MainContainer, PageContent, PageTitle } from '../style';
import { SideBarBack } from '../../../features/side-menu/ui/style';
import React from 'react';
import { LinkExt } from '../../../shared/style/style';

export const Page = () => {
  return (
    <MainContainer>
      <SideBarBack>
        <LinkExt to={'/hot'}>
          <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill="white"
              d="M0.84804 8.05701C0.327346 8.57767 0.327346 9.42194 0.84804 9.94261L8.39052 17.4851C8.91121 18.0058
                9.75547 18.0058 10.2761 17.4851C10.7968 16.9645 10.7968 16.1202 10.2761 15.5995L5.0098
                10.3331H22.6667C23.4031 10.3331 24 9.73621 24 8.99981C24 8.26341 23.4031 7.66647 22.6667
                7.66647H5.0098L10.2761 2.40017C10.7968 1.87946 10.7968 1.03525 10.2761 0.514553C9.75547 -0.00615321
                8.91121 -0.00615321 8.39052 0.514553L0.84804 8.05701Z"
            />
          </svg>
        </LinkExt>
      </SideBarBack>
      <PageTitle> Contact us </PageTitle>
      <PageContent>
        <p>
          You can contact us via email:{' '}
          <a href="mailto:hello@fupp.app" target="_blank" rel="noreferrer">
            hello@fupp.app
          </a>
        </p>
      </PageContent>
      <BottomShadow />
    </MainContainer>
  );
};